module.exports = __webpack_public_path__ + "static/ga_integration_5-2e7f27ffb887e4de35b6af513fc55dbf.png";